export const REACT_NATIVE_COOKIE = "reactnative";
export const REACT_NATIVE_QUERY_PARAM = "reactnative";

export function getCookieValue(
  cookieString: string | undefined,
  name: string
): string | null {
  if (!cookieString) return null;

  const match = cookieString.match(new RegExp(`(^|;) ?${name}=([^;]*)(;|$)`));
  return match ? match[2] : null;
}

export function isEnabledReactNativeValue(
  value: string | null | undefined
): boolean {
  if (value == null) return false;

  const normalized = value.trim().toLowerCase();
  if (!normalized || normalized === "false" || normalized === "0") {
    return false;
  }

  return true;
}

export function isReactNativeApp({
  cookieHeader,
  searchParams
}: {
  cookieHeader?: string;
  searchParams?: URLSearchParams | Pick<URLSearchParams, "get">;
}): boolean {
  if (searchParams) {
    const queryValue = searchParams.get(REACT_NATIVE_QUERY_PARAM);

    if (queryValue !== null) {
      return isEnabledReactNativeValue(queryValue);
    }
  }

  return getCookieValue(cookieHeader, REACT_NATIVE_COOKIE) === "true";
}
